// extracted by mini-css-extract-plugin
module.exports = {"rightArrowSvg":"style__rightArrowSvg___3WXrk","leftArrowSvg":"style__leftArrowSvg___2DCAw"};